import React from "react"
import {
  Button,
  QuestionnaireActionBtns,
  Text,
  Title,
} from "@thedgbrt/logology-ui-components"
import { connect } from "react-redux"
import { navigate } from "gatsby"
import { previousStep, nextStep } from "../../state/actions/questionnaire"
import { useQuestionIntroData } from "./data/useQuestionIntroData"

const IntroSection = ({ id, step, basepath, nextStep }) => {
  // get question intro data from local json file
  const { buttonText, text, title } = useQuestionIntroData()[id]

  return (
    <>
      <Title level={3} last={false}>
        {title}
      </Title>

      <Text lead dangerouslySetInnerHTML={{ __html: text }} />

      <QuestionnaireActionBtns>
        <Button
          onClick={() => {
            nextStep()
            navigate(`${basepath}${step + 1}`)
          }}
        >
          {buttonText + " →"}
        </Button>
      </QuestionnaireActionBtns>
    </>
  )
}
export default connect(
  null,
  { previousStep, nextStep }
)(IntroSection)
